function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobLogoFinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.449,
    height: 20.358,
    viewBox: "0 0 75.449 20.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "mob logo final"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2506",
    d: "M418.792 163a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792 2.792 2.792 0 0 1-2.792-2.792 2.792 2.792 0 0 1 2.792-2.792z",
    transform: "translate(-360.763 -148.36)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2507",
    d: "M418.792 108a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792 2.792 2.792 0 0 1-2.792-2.792 2.792 2.792 0 0 1 2.792-2.792z",
    transform: "translate(-360.763 -100.673)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2508",
    d: "M418.792 53a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792A2.792 2.792 0 0 1 416 55.792 2.792 2.792 0 0 1 418.792 53z",
    transform: "translate(-360.763 -52.987)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2509",
    d: "M473.792 163a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792 2.792 2.792 0 0 1-2.792-2.792 2.792 2.792 0 0 1 2.792-2.792z",
    transform: "translate(-408.449 -148.36)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2510",
    d: "M473.792 108a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792 2.792 2.792 0 0 1-2.792-2.792 2.792 2.792 0 0 1 2.792-2.792z",
    transform: "translate(-408.449 -100.673)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2511",
    d: "M473.792 53a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792A2.792 2.792 0 0 1 471 55.792 2.792 2.792 0 0 1 473.792 53z",
    transform: "translate(-408.449 -52.987)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2512",
    d: "M528.792 108a2.792 2.792 0 0 1 2.792 2.792 2.792 2.792 0 0 1-2.792 2.792 2.792 2.792 0 0 1-2.792-2.792 2.792 2.792 0 0 1 2.792-2.792z",
    transform: "translate(-456.136 -100.673)",
    style: {
      fill: "#00de9d"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M290.1 62.647a7.528 7.528 0 0 0-1.569-2.42 6.939 6.939 0 0 0-2.34-1.582 7.084 7.084 0 0 0-2.859-.572 5.582 5.582 0 0 0-1.024.106 6.86 6.86 0 0 0-1.024.279 5.026 5.026 0 0 0-.918.479 3.382 3.382 0 0 0-.7.665V52.9H276v12.779a7.927 7.927 0 0 0 .572 3.058 7.553 7.553 0 0 0 1.569 2.394 7.243 7.243 0 0 0 2.34 1.569 7.355 7.355 0 0 0 2.859.558 7.547 7.547 0 0 0 2.859-.545 7.172 7.172 0 0 0 2.34-1.542 7.326 7.326 0 0 0 1.569-2.407 7.968 7.968 0 0 0 .572-3.085 7.75 7.75 0 0 0-.58-3.032zm-3.4 4.574a3.707 3.707 0 0 1-.785 1.237 3.915 3.915 0 0 1-1.17.838 3.347 3.347 0 0 1-1.409.293 3.451 3.451 0 0 1-1.436-.289 3.585 3.585 0 0 1-1.157-.838 3.929 3.929 0 0 1-.785-1.237 4.184 4.184 0 0 1-.279-1.542 3.851 3.851 0 0 1 .279-1.449A4.074 4.074 0 0 1 281.9 62.1a3.108 3.108 0 0 1 1.423-.332 3.347 3.347 0 0 1 1.409.293 3.463 3.463 0 0 1 1.17.824 3.993 3.993 0 0 1 .785 1.25 4.213 4.213 0 0 1 0 3.085z",
    transform: "translate(-239.379 -52.9)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.039 93.888a6.837 6.837 0 0 0-2.34-1.542 7.3 7.3 0 0 0-2.859-.545 7.13 7.13 0 0 0-2.859.572 7.465 7.465 0 0 0-2.34 1.6 7.326 7.326 0 0 0-1.569 2.407 7.84 7.84 0 0 0-.572 3.032 7.754 7.754 0 0 0 .572 3.005 7.613 7.613 0 0 0 1.569 2.407 7.77 7.77 0 0 0 2.34 1.6 7.433 7.433 0 0 0 5.718 0 7.77 7.77 0 0 0 2.34-1.6 7.467 7.467 0 0 0 1.569-2.407 7.754 7.754 0 0 0 .572-3.005 8.057 8.057 0 0 0-.572-3.112 7.19 7.19 0 0 0-1.569-2.412zM163.2 101a3.707 3.707 0 0 1-.785 1.237 3.565 3.565 0 0 1-2.58 1.077 3.451 3.451 0 0 1-1.423-.293 3.584 3.584 0 0 1-1.157-.838 4.02 4.02 0 0 1-1.05-2.779 4.37 4.37 0 0 1 .279-1.6 3.676 3.676 0 0 1 .771-1.237 3.469 3.469 0 0 1 1.157-.8 3.668 3.668 0 0 1 1.423-.279 3.556 3.556 0 0 1 1.41.279 3.064 3.064 0 0 1 1.17.8 3.929 3.929 0 0 1 .785 1.237 4.5 4.5 0 0 1 0 3.191z",
    transform: "translate(-132.301 -86.627)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.243 108.627v-9.122a1.752 1.752 0 0 1 .133-.7 1.794 1.794 0 0 1 .386-.585 1.612 1.612 0 0 1 .572-.386 1.858 1.858 0 0 1 .7-.146 1.758 1.758 0 0 1 .7.146 1.6 1.6 0 0 1 .585.386 1.66 1.66 0 0 1 .386.585 1.858 1.858 0 0 1 .146.7v9.122h3.67v-9.122a1.752 1.752 0 0 1 .133-.7 1.794 1.794 0 0 1 .386-.585 1.612 1.612 0 0 1 .572-.386 1.858 1.858 0 0 1 .7-.146 1.758 1.758 0 0 1 .7.146 1.6 1.6 0 0 1 .585.386 1.66 1.66 0 0 1 .403.58 1.858 1.858 0 0 1 .146.7v9.122h3.724v-9a6.115 6.115 0 0 0-2.886-4.973 5.024 5.024 0 0 0-.465-.226A5.2 5.2 0 0 0 13.392 94a5.294 5.294 0 0 0-1.011.093 4.461 4.461 0 0 0-1 .279 4.408 4.408 0 0 0-.9.519 3.6 3.6 0 0 0-.771.785 4.041 4.041 0 0 0-1.689-1.3 5.3 5.3 0 0 0-3.87-.013 5.868 5.868 0 0 0-1.41.785A6.139 6.139 0 0 0 .6 98.96v9.667z",
    transform: "translate(-.6 -88.535)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobLogoFinal);
export default __webpack_public_path__ + "static/media/mob_logo_final.b7e813b10dc17b9506ccc11e2f918a50.svg";
export { ForwardRef as ReactComponent };